import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";

export default function Login() {
  const { user, login, register } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const next = searchParams.get("next") || "/";
  const [mode, setMode] = useState("login");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => { if (user) navigate(next, { replace: true }); }, [user, navigate, next]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      if (mode === "login") await login(email, password);
      else await register(name, email, password);
      navigate(next, { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth on-dark">
      <div className="auth__card">
        <div className="auth__brand">
          <span className="nav__logo">EQUIPR</span>
          <span style={{ fontWeight: "var(--fw-bold)", fontSize: "var(--fs-body-lg)" }}>Academy</span>
        </div>
        <div className="eyebrow-accent" style={{ marginBottom: "8px" }}>Included with every EQUIPR subscription</div>
        <h1 style={{ fontSize: "var(--fs-card-title-lg)", fontWeight: "var(--fw-extrabold)", letterSpacing: "var(--ls-headline)", margin: "0 0 20px" }}>
          {mode === "login" ? "Sign in to learn your role." : "Create your Academy account."}
        </h1>

        <div className="auth__tabs">
          <button type="button" className={`tab ${mode === "login" ? "tab--active" : ""}`} onClick={() => { setMode("login"); setError(""); }} data-testid="tab-login">Sign in</button>
          <button type="button" className={`tab ${mode === "register" ? "tab--active" : ""}`} onClick={() => { setMode("register"); setError(""); }} data-testid="tab-register">Register</button>
        </div>

        {error && <div className="auth__error" data-testid="auth-error">{error}</div>}

        <form onSubmit={submit}>
          {mode === "register" && (
            <div className="auth__field">
              <label className="label" htmlFor="name">Full name</label>
              <input id="name" className="input" value={name} onChange={(e) => setName(e.target.value)} required data-testid="register-name" placeholder="Jess Mannering" />
            </div>
          )}
          <div className="auth__field">
            <label className="label" htmlFor="email">Email</label>
            <input id="email" type="email" className="input" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" placeholder="you@company.com" />
          </div>
          <div className="auth__field">
            <label className="label" htmlFor="password">Password</label>
            <input id="password" type="password" className="input" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" placeholder="••••••••" />
          </div>
          <button type="submit" className="btn btn--dark btn--block" disabled={busy} data-testid="login-submit">
            {busy ? "Please wait…" : mode === "login" ? "Sign in" : "Create account"}
          </button>
        </form>

        <p className="auth__hint">
          Demo learner — <strong>jess@equipr.software</strong> / <strong>Academy123!</strong>
        </p>
      </div>
    </div>
  );
}
